"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Button_1 = require("../../Button");
var helpers_1 = require("./helpers");
var StackView_1 = require("../../StackView");
var helpers_2 = require("../../helpers");
var View_1 = require("../../View");
var TimeSelector_1 = require("../../helpers/TimeSelector");
var Root = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", ";\n"], ["\n    padding: ", ";\n"])), helpers_2.SPACING_M);
var StyledButton = styled_components_1.default(Button_1.Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    min-width: 80px;\n"], ["\n    min-width: 80px;\n"])));
var Footer = styled_components_1.default(StackView_1.StackView)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    min-height: ", ";\n"], ["\n    min-height: ", ";\n"])), helpers_2.SPACING_XL);
var convert12To24HourFormat = function (hours, isAMTimePeriod) {
    if (hours === 12) {
        return isAMTimePeriod ? 0 : 12;
    }
    return isAMTimePeriod ? hours : hours + 12;
};
exports.TimePickerPopover = function (_a) {
    var value = _a.value, is12Hours = _a.is12Hours, onSelect = _a.onSelect, texts = _a.texts, onMouseDown = _a.onMouseDown, onRequestClose = _a.onRequestClose;
    var initialDraftHours = value ? value.hours : null;
    if (value && is12Hours && value.hours > 12) {
        initialDraftHours = value.hours - 12;
    }
    if (value && is12Hours && value.hours === 0) {
        initialDraftHours = 12;
    }
    var _b = react_1.useState(initialDraftHours), draftHours = _b[0], setDraftHours = _b[1];
    var _c = react_1.useState(value ? value.minutes : null), draftMinutes = _c[0], setDraftMinutes = _c[1];
    var _d = react_1.useState(!(value && value.hours >= 12)), draftIsAmTimePeriod = _d[0], setDraftIsAmTimePeriod = _d[1];
    var _e = react_1.useState({
        hours: false,
        minutes: false
    }), errorState = _e[0], setErrorState = _e[1];
    var onHoursChange = function (hours) {
        setDraftHours(hours);
        setErrorState(__assign(__assign({}, errorState), { hours: false }));
    };
    var onMinutesChange = function (minutes) {
        setDraftMinutes(minutes);
        setErrorState(__assign(__assign({}, errorState), { minutes: false }));
    };
    var onTimePeriodChange = function (isAmTimePeriod) {
        setDraftIsAmTimePeriod(isAmTimePeriod);
    };
    var onApply = function () {
        setErrorState({
            hours: draftHours === null,
            minutes: draftMinutes === null
        });
        if (onSelect && draftHours !== null && draftMinutes !== null) {
            onSelect({
                hours: is12Hours
                    ? convert12To24HourFormat(draftHours, draftIsAmTimePeriod)
                    : draftHours,
                minutes: draftMinutes
            });
            onRequestClose === null || onRequestClose === void 0 ? void 0 : onRequestClose();
        }
    };
    return (react_1.default.createElement(Root, { "data-selector-id": helpers_1.dataSelectorId.timeSelector },
        react_1.default.createElement(TimeSelector_1.TimeSelector, { is12Hours: is12Hours, hours: draftHours, minutes: draftMinutes, isAmTimePeriod: draftIsAmTimePeriod, onHoursChange: onHoursChange, onMinutesChange: onMinutesChange, onPeriodChange: onTimePeriodChange, texts: texts, errorHours: errorState.hours, errorMinutes: errorState.minutes }),
        react_1.default.createElement(Footer, { indentTop: View_1.INDENT.xl, gap: StackView_1.STACK_GAP.m, distribution: StackView_1.STACK_DISTRIBUTION.end, align: StackView_1.STACK_ALIGN.center, spaceFill: View_1.SPACE_FILL.all, onMouseDown: onMouseDown },
            react_1.default.createElement(StyledButton, { "data-selector-id": helpers_1.dataSelectorId.applyControl, onClick: onApply }, texts.apply),
            react_1.default.createElement(StyledButton, { "data-selector-id": helpers_1.dataSelectorId.cancelControl, ui: Button_1.BUTTON_VIEW.secondary, onClick: onRequestClose }, texts.cancel))));
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=TimePickerPopover.js.map